import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, useNavigate  } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../api/ProtectAPi';
import { ServerUrl } from '../../../../api/ServerUrl';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';

const ServicesEdit = () => {
  const { http } = ProtectAPi();
  const editor = useRef(null);
  const { id } = useParams();
  const [loader, setLoader] = useState('off');
  const navigate = useNavigate();

  const [layoutTitle, setLayoutTitle] = useState('');
  const [layoutSlug, setLayoutSlug] = useState('');
  const [layoutAltText, setLayoutAltText] = useState('');
  const [layoutDescription, setLayoutDescription] = useState('');
  const [layoutImage, setLayoutImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');

  // UPDATED: priority
  const [priority, setPriority] = useState('');

  const [status, setStatus] = useState(1);

  // Error states
  const [layoutImageError, setLayoutImageError] = useState('');
  const [titleError, setTitleError] = useState('');
  const [slugError, setSlugError] = useState('');
  const [altTextError, setAltTextError] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [priorityError, setPriorityError] = useState('');
  const [statusError, setStatusError] = useState('');

  const httpCPage = ServerUrl;

  useEffect(() => {
    http.get(`/get-single-services/${id}`)
      .then(res => {
        const data = res.data || {};
        setLayoutTitle(data.title || '');
        setLayoutSlug(data.slug || '');
        setLayoutAltText(data.alt || '');
        setLayoutDescription(data.description || '');
        setStatus(data.status !== undefined ? Number(data.status) : 1);

        // updated priority
        setPriority(data.priority !== undefined ? String(data.priority) : '');

        if (data.image) {
          setImagePreview(`${httpCPage}/backend/img/services/${data.image}`);
        }
      })
      .catch(error => {
        console.error('Error fetching service:', error);
      });

  }, [id]);

  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    setLayoutImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handlePriorityChange = (e) => {
    setPriority(e.target.value); // string রাখছি যাতে empty allow হয়
  };

  const handleStatusChange = (e) => {
    setStatus(Number(e.target.value));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'layoutTitle') setLayoutTitle(value);
    if (name === 'layoutSlug') setLayoutSlug(value);
    if (name === 'layoutAltText') setLayoutAltText(value);
  };

  const submitForm = () => {
    setLoader('on');
    setLayoutImageError('');
    setTitleError('');
    setSlugError('');
    setAltTextError('');
    setDescriptionError('');
    setPriorityError('');
    setStatusError('');

    const formData = new FormData();
    formData.append('title', layoutTitle);
    formData.append('slug', layoutSlug);
    formData.append('alt_text', layoutAltText);
    formData.append('description', layoutDescription);

    if (layoutImage) formData.append('image', layoutImage);

    // hidden
    formData.append('type', 1);

    // updated priority field
    formData.append('priority', priority || '');

    formData.append('status', String(status));

    http.post(`/update-services/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(res => {
        if (res.data.status === '422') {
          const errors = res.data.error || {};
          setLoader('off');
          setLayoutImageError(errors.image?.[0] || '');
          setTitleError(errors.title?.[0] || '');
          setSlugError(errors.slug?.[0] || '');
          setAltTextError(errors.alt_text?.[0] || '');
          setDescriptionError(errors.description?.[0] || '');
          setPriorityError(errors.priority?.[0] || '');
          setStatusError(errors.status?.[0] || '');
        } else {
          setLoader('off');
          swal('Success', res.data.msg, 'success').then(() => {
            navigate('/admin/pages/home/services-list');
          });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setLoader('off');
      });
  };

  const editorConfig = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing...',
    uploader: { insertImageAsBase64URI: true }
  }), []);

  return (
    <div className="main-content">
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card card-primary">
                <div className="card-body">

                  <div className="d-flex justify-content-between">
                    <h5>Edit Services</h5>
                    <BackButton />
                  </div>

                  <div className="row mt-3">
                    
                    {/* hidden */}
                    <input type="hidden" name="type" value="1" />





                    {/* Image */}
                                        <div className="col-md-4">
                                            <label>Services Image</label>

                                            <div className="logo-box w-100">
                                                <div className="logo w-100">
                                                    <label htmlFor="layoutImage" className="w-100">

                                                        {/* FIXED container width */}
                                                        <div
                                                            className="image-box border border-dotted p-2 rounded w-100"
                                                            style={{
                                                                width: "100%",
                                                                height: "165px",
                                                                overflow: "hidden",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}
                                                        >
                                                            {imagePreview ? (
                                                                <img
                                                                    src={imagePreview}
                                                                    alt="Preview"
                                                                    className='rounded'
                                                                    style={{ borderRadius: "5PX", width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png"
                                                                    alt="Default"
                                                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                                                />
                                                            )}
                                                        </div>

                                                        <input
                                                            type="file"
                                                            id="layoutImage"
                                                            className="form-control d-none"
                                                            onChange={handleImageChange}
                                                        />

                                                        <span className="btn btn-primary mt-3 w-100">Upload Services Image</span>
                                                        <span className="text-danger">{layoutImageError}</span>

                                                    </label>
                                                </div>
                                            </div>
                                        </div>





                    {/* Right side */}
                    <div className="col-md-8">
                      <div className="row">
                        
                        <div className="col-12">
                          <label>Alt Text for Image</label>
                          <input type="text" className="form-control" name="layoutAltText" value={layoutAltText} onChange={handleInputChange} placeholder="Enter alt text" />
                          <span className="text-danger">{altTextError}</span>
                        </div>

                        <div className="col-12 mt-3">
                          <label>Title</label>
                          <input type="text" className="form-control" name="layoutTitle" value={layoutTitle} onChange={handleInputChange} placeholder="Enter title" />
                          <span className="text-danger">{titleError}</span>
                        </div>

                        <div className="col-12 mt-3">
                          <label>Slug (optional)</label>
                          <input type="text" className="form-control" name="layoutSlug" value={layoutSlug} onChange={handleInputChange} placeholder="Enter slug" />
                          <span className="text-danger">{slugError}</span>
                        </div>

                      </div>
                    </div>

                    {/* Status */}
                    <div className="col-md-6 mt-3">
                      <label>Status</label>
                      <select className="form-control" value={status} onChange={handleStatusChange}>
                        <option value={1}>Active</option>
                        <option value={2}>Inactive</option>
                      </select>
                      <span className="text-danger">{statusError}</span>
                    </div>

                    {/* PRIORITY (UPDATED) */}
                    <div className="col-md-6 mt-3">
                      <label>Priority</label>
                      <input
                        type="number"
                        className="form-control"
                        value={priority}
                        onChange={handlePriorityChange}
                        placeholder="Enter priority"
                      />
                      <span className="text-danger">{priorityError}</span>
                    </div>

                    {/* Description */}
                    <div className="col-md-12 mt-5">
                      <label>Description</label>
                      <JoditEditor
                        ref={editor}
                        value={layoutDescription}
                        config={{ ...editorConfig, height: 300 }}
                        onBlur={(v) => setLayoutDescription(v)}
                      />
                      <span className="text-danger">{descriptionError}</span>
                    </div>

                    {/* Button */}
                    <div className="col-md-12 text-center mt-5 mb-4">
                      {loader === 'off' ? (
                        <button onClick={submitForm} className="btn btn-lg btn-primary">Update</button>
                      ) : (
                        <div className="spinner-border text-dark"></div>
                      )}
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesEdit;
